export class ContractHttpResponse<T>  {
    public Source: T;
    public Success: boolean;
    public Message: string;
}
